import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { LOGGER_CONFIG, HTTP_CONFIG, AUTH_CONFIG } from './configs';
import { ErrorModule } from './core/error/error.module';
import { AuthModule } from './core/auth/auth.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { MainMenuComponent } from './shared/components/mainmenu/mainmenu.component';
import { SharedWebModule } from './shared/shared-web.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MainMenuComponent
  ],
  imports: [
    BrowserModule,
    CoreModule.forRoot(LOGGER_CONFIG, HTTP_CONFIG),
    AuthModule.forRoot(AUTH_CONFIG),
    ErrorModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedWebModule
  ],
  exports:[
    HeaderComponent,
    FooterComponent,
    MainMenuComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
